var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCredentialsLeak = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D5B66",
    d: "M23.026 7.679v6.262a35 35 0 0 0-2.265-2.652.78.78 0 0 0-1.124 0c-.048.05-1.194 1.242-2.356 2.77-1.652 2.172-2.457 3.833-2.457 5.077 0 1.245.39 2.295 1.049 3.187H5.264a1.13 1.13 0 0 1-1.127-1.127V4.561c0-.622.506-1.127 1.127-1.127h6.394c.301 0 .585.117.797.33l2.687 2.687a.34.34 0 0 0 .245.101h6.512c.621 0 1.127.506 1.127 1.127"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D5B66",
    d: "M20.2 12.976c-1.665 1.846-3.815 4.713-3.815 6.16a3.82 3.82 0 0 0 3.814 3.815 3.82 3.82 0 0 0 3.814-3.815c0-1.447-2.149-4.314-3.814-6.16"
  })));
};
export default SvgCredentialsLeak;